/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ambiguous_LoginInputs */



/**

* @param {Ambiguous_LoginInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const ambiguous_login = /** @type {((inputs?: Ambiguous_LoginInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ambiguous_LoginInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Anmeldung nicht möglich. Bitte wenden Sie sich an die Administration.")
});